import { Button } from 'components/Button';
import { IconButton } from 'components/IconButton/IconButton';
import React, { MouseEventHandler } from 'react';
import { useTranslation } from 'react-i18next';
import { shareViaEmail } from 'utils/sharing.utils';
import { InsightsTitle, InsightsTitleProps } from './InsightsTitle';

export type InsightsCardProps = InsightsTitleProps & {
  image: string;
  description: string;
  link: string | null;
  iconButtonAction?: () => void;
  buttonAction?: MouseEventHandler;
};

export const InsightsCard: React.FC<InsightsCardProps> = ({
  title,
  image,
  date,
  location,
  newInsight,
  categories,
  marketSegment,
  sustainable,
  description,
  link,
  iconButtonAction,
  buttonAction,
}) => {
  const { t } = useTranslation(undefined, {
    keyPrefix: 'features:insights:market-insights',
  });

  const onClickShare = () => {
    //sharing
    shareViaEmail(
      title,
      link ?? '',
      description,
      t('email:intro'),
      t('email:outro'),
      t('email:subject'),
    );

    //for tracking insights
    if (iconButtonAction) {
      iconButtonAction();
    }
  };

  return (
    <div className="border-grey-300 rounded-4px flex w-full flex-col gap-4 border p-3 md:p-4 lg:flex-row">
      <div className="flex flex-col gap-4 sm:flex-row lg:block lg:shrink-0">
        <img
          alt="insights-image"
          className="rounded-4px w-full sm:h-[128px] sm:w-[171px] lg:h-[300px] lg:w-[400px]"
          src={image}
        />
        {/* Mobile Title Start */}
        <div className="flex flex-col gap-2 lg:hidden">
          <InsightsTitle
            title={title}
            date={date}
            location={location}
            categories={categories}
            marketSegment={marketSegment}
            sustainable={sustainable}
            newInsight={newInsight}
          />
        </div>
        {/* Mobile Title End */}
      </div>
      <div className="flex w-full flex-col justify-between">
        <div className="flex flex-col gap-3">
          {/* Desktop Title Start */}
          <div className="hidden flex-col gap-3 lg:flex">
            <InsightsTitle
              title={title}
              date={date}
              location={location}
              categories={categories}
              marketSegment={marketSegment}
              sustainable={sustainable}
              newInsight={newInsight}
            />
          </div>
          {/* Desktop Title End */}
          <p className="text-grey-700 font-base">{description}</p>
        </div>
        <div className="mt-4 flex justify-between gap-4">
          <IconButton
            icon="Share"
            tooltip={t('share')}
            onClick={onClickShare}
          />
          {link ? (
            <a href={link} target="_blank" rel="noreferrer">
              <Button
                label="Read more"
                //for tracking insights
                onClick={buttonAction}
              />
            </a>
          ) : null}
        </div>
      </div>
    </div>
  );
};
